import { Link, createFileRoute } from '@tanstack/react-router'
import { getPosts, type PostListItem } from '../lib/blog'

export const Route = createFileRoute('/perspectives' as any)({
  loader: async () => {
    const posts = await getPosts()
    return { posts }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { posts } = Route.useLoaderData() as { posts: PostListItem[] }

  return (
    <div className="min-h-screen w-full bg-white text-black">
      <div className="mx-auto max-w-5xl px-4 py-12 md:px-6 md:py-16">
        <header className="mb-10">
          <h1 className="text-3xl font-sans md:text-4xl">Perspectives</h1>
          <p className="mt-2 text-sm text-gray-600">
            Insights and thought leadership from CoPlane
          </p>
        </header>

        <ul className="space-y-6">
          {posts.map((post) => (
            <li key={post.slug} className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-sans md:text-2xl">
                <Link
                  to="/perspectives/$slug"
                  params={{ slug: post.slug }}
                  className="hover:underline"
                >
                  {post.frontmatter.title}
                </Link>
              </h2>
              <div className="mt-1 text-xs text-gray-500">
                {new Date(post.frontmatter.date).toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </div>
              <p className="mt-3 text-sm text-gray-800">
                {post.frontmatter.description}
              </p>
              {post.frontmatter.tags && post.frontmatter.tags.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {post.frontmatter.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded border border-gray-300 px-2 py-0.5 text-xs text-gray-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}


